import makeTag from 'lib/utils/dom';

export default {
  data() {
    return {
      scriptList: [],
    };
  },
  methods: {
    injectScripts() {
      const scripts = [
        '/assets/tilda/js/tilda-scripts-2.8.min.js',
        '/assets/tilda/js/tilda-blocks-2.7.js?t=1601414475',
        '/assets/tilda/js/lazyload-1.3.min.js',
        '/assets/tilda/js/tilda-animation-1.0.min.js',
        '/assets/tilda/js/tilda-slds-1.4.min.js',
        '/assets/tilda/js/hammer.min.js',
        '/assets/tilda/js/tilda-zoom-2.0.min.js',
        '/assets/tilda/js/tilda-animation-ext-1.0.min.js',
        '/assets/tilda/js/tilda-menusub-1.0.min.js',
      ];

      scripts.forEach((scriptSrc) => {
        const scriptTag = makeTag('script', scriptSrc);
        const script = document.body.appendChild(scriptTag);
        this.scriptList.push(script);
      });
    },
    removeInjectedScripts() {
      if (!this.scriptList) {
        return;
      }
      this.scriptList.forEach((script) => {
        if (script && script instanceof HTMLScriptElement) {
          script.remove();
        }
      });
    },
  },
};
